import { css } from "@emotion/css";
import { useEffect, useState } from "react";
import { TextH2 } from "../DesignSystem/DesignSystemText";
import LayoutCol from "../DesignSystem/Layout/LayoutCol";
import LayoutContainer from "../DesignSystem/Layout/LayoutContainer";

const fadeIn = css`
  transition: opacity 0.5s ease;
`;

const fadeOut = css`
  opacity: 0;
  transition: opacity 0.5s ease;
`;

function shuffle(array: string[]): string[] {
  for (let i = array.length - 1; i > 1; i--) {
    const j = Math.floor(Math.random() * i);
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

const MintingLoader: React.VFC<{
  shuffle?: boolean;
  initialMessage?: string;
}> = (props) => {
  const [loadingTextOptions, setLoadingTextOptions] = useState([
    props.initialMessage ? props.initialMessage : "Minting Kudos...",
    "Adding a splash of gradient...",
    "Dotting the i's...",
    "Crossing the t's...",
    "Mixing in the glitter...",
    "Sprinkling in a dash of confetti...",
    "Assembling final touches...",
    "Breaking into the Metaverse...",
    "Saying gm to Vitalik...",
    "Aping into another NFT Project...",
  ]);
  const [loadingTextIndex, setLoadingTextIndex] = useState(-1);
  const [fadeAnimation, setFadeAnimation] = useState(fadeOut);

  // Change loading text and alternate between fade in and fade out transitions every 1.5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      if (fadeAnimation == fadeIn) {
        setFadeAnimation(fadeOut);
      } else {
        setLoadingTextIndex((loadingTextIndex + 1) % loadingTextOptions.length);
        setFadeAnimation(fadeIn);
      }
    }, 1400);
    return () => clearInterval(interval);
  }, [fadeAnimation]);

  // Shuffle loading text options upon page load except for first item since we want to start with "Minting kudos..."
  useEffect(() => {
    if (!props.shuffle) return;

    setLoadingTextOptions([
      loadingTextOptions[0],
      ...shuffle(loadingTextOptions.slice(1)),
    ]);
    setLoadingTextIndex(0);
  }, [props.shuffle]);

  return (
    <>
      <LayoutContainer
        className={css`
          position: absolute;
          top: 0;
          bottom: 0;
        `}
        center={true}
      >
        <LayoutCol
          className={css`
            height: 100%;
          `}
          alignX="center"
          alignY="center"
        >
          <>
            <TextH2 className={fadeAnimation}>
              <>{loadingTextOptions[loadingTextIndex]}</>
            </TextH2>
          </>
        </LayoutCol>
      </LayoutContainer>
    </>
  );
};

export default MintingLoader;
